<a class="btn btn-outline-primary mb-3" [ariaLabel]="label" [title]="label">
  {{ label }}
</a>
